const ICON_EXPAND_BOTTOM = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      d="M2.414.25h5.172A2.16 2.16 0 0 1 9.75 2.414v5.172A2.16 2.16 0 0 1 7.586 9.75H2.414A2.16 2.16 0 0 1 .25 7.586V2.414A2.16 2.16 0 0 1 2.414.25z"
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        stroke: color,
      }}
    />
    <path
      d="M7.234 4.065 5 6.342 2.766 4.066"
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeWidth: 0.5,
        stroke: color,
      }}
    />
  </svg>
);

export default ICON_EXPAND_BOTTOM;
